import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Pipe({
  name: 'formGroupGet'
})
export class FormGroupGetPipe implements PipeTransform {

  transform(form: FormGroup, name: string): AbstractControl {
    return form.get(name);
  }

}
